import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TANGMANGO_URL = "https://academy.bymatautomation.com/web/checkout/693e9b7b5492b07ca049f92c";

const USE_MOCK = !BACKEND_URL || BACKEND_URL.includes("undefined");

export const createLead = async (payload) => {
  if (USE_MOCK) {
    // Mock response for development without backend
    console.log("📌 DEV MODE: Using mock API response. Payload:", payload);
    await new Promise(r => setTimeout(r, 500)); // Simulate network delay
    return { 
      id: "mock-" + Date.now(), 
      ...payload,
      created_at: new Date().toISOString()
    };
  }
  
  try {
    const res = await axios.post(`${API}/leads`, payload);
    return res.data;
  } catch (error) {
    console.error("API Error:", error.message);
    if (error.code === 'ERR_NETWORK') {
      console.error("❌ Cannot connect to backend at", API);
      console.error("ℹ️  Is the backend server running?");
    }
    throw error;
  }
};

export const fetchLeads = async () => {
  const res = await axios.get(`${API}/leads`);
  return res.data;
};

export const fetchSettings = async () => {
  const res = await axios.get(`${API}/settings`);
  return res.data;
};

export const updateSettings = async (payload) => {
  const res = await axios.put(`${API}/settings`, payload);
  return res.data;
};
